__turbopack_context__.v({
  "blogCard": "blog-card-module-scss-module__86zqAG__blogCard",
  "blogCard__list": "blog-card-module-scss-module__86zqAG__blogCard__list",
  "blogCard_action": "blog-card-module-scss-module__86zqAG__blogCard_action",
  "blogCard_body": "blog-card-module-scss-module__86zqAG__blogCard_body",
  "blogCard_content": "blog-card-module-scss-module__86zqAG__blogCard_content",
  "blogCard_description": "blog-card-module-scss-module__86zqAG__blogCard_description",
  "blogCard_image": "blog-card-module-scss-module__86zqAG__blogCard_image",
  "blogCard_imageContainer": "blog-card-module-scss-module__86zqAG__blogCard_imageContainer",
  "blogCard_link": "blog-card-module-scss-module__86zqAG__blogCard_link",
  "blogCard_skeleton": "blog-card-module-scss-module__86zqAG__blogCard_skeleton",
  "blogCard_title": "blog-card-module-scss-module__86zqAG__blogCard_title",
});
